import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Notification } from '@auth/models/notification.model';
import { NotificationService } from '@auth/services/notification.service';
import { DD_MM_YYYY } from '@shared/constants';
import { format, isValid } from 'date-fns';
import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonModule } from 'pu-core-library';

@Component({
  standalone: true,
  selector: 'app-modal-notifications',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './modal-notifications.component.html',
  styleUrl: './modal-notifications.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalNotificationsComponent implements OnInit {
  notifications: Notification[] = [];
  currentIndex = 0;
  submitting = false;
  readAtDate = '';
  readAtTime = '';

  constructor(
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    if (this.dynamicDialogConfig?.data?.notifications) {
      this.notifications = this.dynamicDialogConfig.data.notifications;
    }

    this.setReadAtValues(new Date());
  }

  confirm(): void {
    if (!this.isLastNotification) {
      this.currentIndex++;
      return;
    }

    const notificationIds = this.notifications
      .map(({ id }) => id)
      .filter((id): id is number => typeof id === 'number');

    if (!notificationIds.length) {
      this.dynamicDialogRef.close();
      return;
    }

    this.submitting = true;
    this.notificationService.markNotificationsAsReadForCurrentUser(notificationIds).subscribe({
      next: () => {
        this.submitting = false;
        this.dynamicDialogRef.close();
      },
      error: () => {
        this.submitting = false;
        this.dynamicDialogRef.close();
      },
    });
  }

  get currentNotification(): Notification | null {
    return this.notifications[this.currentIndex] || null;
  }

  get isLastNotification(): boolean {
    return this.currentIndex === this.notifications.length - 1;
  }

  get currentNotificationDate(): string | null {
    if (!this.currentNotification?.startDate) {
      return null;
    }

    const date = new Date(this.currentNotification.startDate);
    if (!isValid(date)) {
      return null;
    }

    return format(date, DD_MM_YYYY);
  }

  private setReadAtValues(date: Date): void {
    this.readAtDate = format(date, DD_MM_YYYY);
    this.readAtTime = format(date, 'HH:mm');
  }
}
